import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import LandingPage from "@/pages/LandingPage";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import ShareView from "@/pages/ShareView";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import OccasionDashboard from "@/pages/OccasionDashboard";
import ContributorPortal from "@/pages/ContributorPortal";
import VirtualStudio from "@/pages/VirtualStudio";
import Profile from "@/pages/Profile";
import PDFStudio from "@/pages/PDFStudio";
import ExportPage from "@/pages/ExportPage";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import Contact from "@/pages/Contact";
import Pricing from "@/pages/Pricing";
import OrderHistory from "@/pages/OrderHistory";
import AdminPricing from "@/pages/AdminPricing";
import { Toaster } from "sonner";

// CRITICAL: Detect session_id synchronously during render (NOT in useEffect).
// This prevents race conditions where App's auth check runs before session is established.
function AppRouter() {
  const location = useLocation();

  // If URL hash contains session_id, render AuthCallback FIRST
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/app" element={<App />} />
      <Route path="/login" element={<Login />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/share/:shareToken" element={<ShareView />} />
      <Route path="/occasions" element={<OccasionDashboard />} />
      <Route path="/contribute/:slug" element={<ContributorPortal />} />
      <Route path="/studio/:bookId" element={<VirtualStudio />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/pdf-studio/:storyId" element={<PDFStudio />} />
      <Route path="/export/:storyId" element={<ExportPage />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="/admin-pricing" element={<AdminPricing />} />
      <Route path="/orders" element={<OrderHistory />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/refund" element={<Refund />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
    <Toaster position="top-right" richColors />
  </React.StrictMode>,
);
